import React from 'react';
import DataTable from './DataTable';

const TabContent = ({
  rows,
  setRows,
  data,
  onAddScenario,
  onPreview,
  onViewFiles,
  processedData,
  handleSearch,
  searchTerm,
  showViewData,
}) => (
  <div className="tab-content">
    <DataTable
      rows={rows}
      setRows={setRows}
      processedData={processedData}
      data={data}
      onAddScenario={onAddScenario}
      onPreview={onPreview}
      onViewFiles={onViewFiles}
    />
  </div>
);

export default TabContent; 